module.exports = __webpack_public_path__ + "img/GH-kyujin-top-036.16e7dcd4.webp";